'use strict';

/** @type {import('./uri')} */
module.exports = URIError;



//////////////////
// WEBPACK FOOTER
// ./~/_es-errors@1.3.0@es-errors/uri.js
// module id = 1227
// module chunks = 5